import { getRouteApi } from '@tanstack/react-router';
import { useCallback } from 'react';

import { definedSearchParams } from '@/lib/search-params';

import { ExercisesScreen } from './ExercisesScreen';
import type { ExercisesSearch } from './exercises-search';

const route = getRouteApi('/exercises');

export function ExercisesRoute() {
  const search = route.useSearch();
  const navigate = route.useNavigate();

  const onSearchChange = useCallback(
    (next: ExercisesSearch) => {
      void navigate({
        replace: true,
        // A cleared filter leaves the URL rather than lingering as `?muscle=`.
        // The warning this comment used to carry — that a field left out is a
        // filter silently dropped on the way to the URL — is now enforced by
        // `definedSearchParams` rather than by remembering.
        search: () => definedSearchParams(next),
      });
    },
    [navigate],
  );

  const onOpenExercise = useCallback(
    (exerciseId: string) => {
      void navigate({ to: '/exercises/$exerciseId', params: { exerciseId } });
    },
    [navigate],
  );

  const onNewExercise = useCallback(() => {
    void navigate({ to: '/exercises/new' });
  }, [navigate]);

  return (
    <ExercisesScreen
      search={search}
      onSearchChange={onSearchChange}
      onOpenExercise={onOpenExercise}
      onNewExercise={onNewExercise}
    />
  );
}
